import { LogCache } from '@/modules/cache/log'

export class Log {
    static SUCCESS = 'success'
    static ERROR = 'error'
    static INFO = 'info'
    static WARNING = 'warning'
    static DEFAULT = undefined

	static _cache = new LogCache
    static _subscribers = []

    static subscribe(callback) {
    	Log._subscribers.push(callback)
    }

    static unsubscribe(callback) {
    	Log._subscribers = Log._subscribers.filter(subscriber => subscriber !== callback)
    }

    static _log(type, message) {
    	Log._subscribers.forEach(subscriber => subscriber(type, message))
    	Log._cache.set({ type, message })
    }

    static success(message) {
    	Log._log(Log.SUCCESS, message)
    }

    static error(message) {
    	Log._log(Log.ERROR, message)
    }

    static info(message) {
    	Log._log(Log.INFO, message)
    }

    static warning(message) {
    	Log._log(Log.WARNING, message)
    }
    
    static log(message) {
    	Log._log(Log.DEFAULT, message)
    }

    static async fetchAll() {
    	Log._cache.clean()
    	const logs = await Log._cache.all()
    	logs.sort((a, b) => a.timestamp < b.timestamp ? 1 : -1)
    	logs.slice(5000).forEach(item => Log._cache.remove(item.uid))
    	return logs.slice(0, 5000).map(log => ({ ...log, ...log.value }))
    }
}

const _console = console

const newConsole = {
	log: (...args) => {
		_console.log(...args)
		Log.log(args.map(a => JSON.stringify(a) || `${a}`).join(' '))
	},
	warn: (...args) => {
		_console.warn(...args)
		Log.warning(args.map(a => JSON.stringify(a) || `${a}`).join(' '))
	},
	error: (...args) => {
		_console.error(...args)
		Log.error(args.map(a => typeof a === 'object' ? JSON.stringify(a) : `${a}`).join(' '))
	},
	info: (...args) => {
		_console.info(...args)
		Log.info(args.map(a => JSON.stringify(a) || `${a}`).join(' '))
	},
}

window.console = newConsole